export type PROGRESS_STATUS = 'loaded' | 'pending' | 'error' | 'partialError' | 'unloaded'

export const PROGRESS_TYPES: {
  LOADED: PROGRESS_STATUS,
  PENDING: PROGRESS_STATUS,
  ERROR: PROGRESS_STATUS,
  PARTIAL_ERROR: PROGRESS_STATUS,
  UNLOADED: PROGRESS_STATUS,
} = {
  UNLOADED: 'unloaded',
  LOADED: 'loaded',
  PENDING: 'pending',
  ERROR: 'error',
  PARTIAL_ERROR: 'partialError'
}
